import { Button, Checkbox } from 'antd';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';
import { formatAmount } from '@share/utils';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import './style.scss';
import { Loading } from '../common';
import { LoadingSise } from '@common-types';

interface CreditLineInvoiceDetail {
  creditLineInvoiceDetailId: number;
  bookingId: number;
  paid: boolean;
  paidDate: string;
  amount: number;
}

interface RecordType {
  creditLineInvoiceId: number;
  created: string;
  amount: number;
  urlPdf: string;
  dueDate: string;
  comments: string;
  paymentStatus: string;
  paidDate: string;
  accountName: string;
  creditLineInvoiceDetails: CreditLineInvoiceDetail[];
}

interface CompanyCreditLineDetailsProps {
  record: RecordType;
  handleBankListModalOpen: () => void;
  handleBankListModalClose: () => void;
  handleCloseModal: () => void;
  checked: { creditLineInvoiceDetailId: number[] };
  isPaymentloading: boolean;
  handleCheckboxChange: (
    event: React.ChangeEvent<HTMLInputElement> | CheckboxChangeEvent,
    record: CreditLineInvoiceDetail,
  ) => void;
  handleBankSelection: (e: React.ChangeEvent<HTMLInputElement>, bank: any) => void;
}

const CompanyCreditLineDetails: React.FC<CompanyCreditLineDetailsProps> = ({
  record,
  checked,
  isPaymentloading,
  handleCheckboxChange,
  handleBankListModalOpen,
  handleCloseModal,
}) => {
  return (
    <>
      <div className="bookingDetail">
        <h2><FormattedMessage id="invoice.overview" /></h2>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4">
            <div className="bookingDetail_item">
              <h3><FormattedMessage id="invoice.status" /></h3>
              <span>{record.paymentStatus}</span>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bookingDetail_item">
              <h3><FormattedMessage id="invoice.id" /></h3>
              <span>{record.creditLineInvoiceId}</span>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bookingDetail_item">
              <h3><FormattedMessage id="invoice.total" /></h3>
              <span>${formatAmount(record.amount)}</span>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bookingDetail_item">
              <h3><FormattedMessage id="invoice.paidOn" /></h3>
              <span>{record.paidDate}</span>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bookingDetail_item">
              <h3><FormattedMessage id="invoice.startDate" /></h3>
              <span>{record.created}</span>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="bookingDetail_item">
              <h3><FormattedMessage id="invoice.endDate" /></h3>
              <span>{record.paidDate}</span>
            </div>
          </div>
        </div>
        <div className="mt-4 d-flex flex-column" id="record-list">
          <h2 className="mt-3"><FormattedMessage id="invoice.bookings.title" /></h2>
          <div className="invoice-row bg-secondary text-white">
            <div className="invoice-cell"><FormattedMessage id="invoice.bookings.exclusions" /></div>
            <div className="invoice-cell"><FormattedMessage id="invoice.bookings.invoiceId" /></div>
            <div className="invoice-cell"><FormattedMessage id="invoice.bookings.bookingId" /></div>
            <div className="invoice-cell"><FormattedMessage id="invoice.bookings.paid" /></div>
            <div className="invoice-cell"><FormattedMessage id="invoice.bookings.paidDate" /></div>
            <div className="invoice-cell"><FormattedMessage id="invoice.bookings.amount" /></div>
          </div>
          {record.creditLineInvoiceDetails?.map((record, index) => (
            <div className="invoice-row" key={record.creditLineInvoiceDetailId}>
              <div className="invoice-cell">
                <Checkbox
                  checked={checked.creditLineInvoiceDetailId.includes(
                    record?.creditLineInvoiceDetailId,
                  )}
                  onChange={(event) => handleCheckboxChange(event, record)}
                />
              </div>
              <div className="invoice-cell">{record.creditLineInvoiceDetailId}</div>
              <div className="invoice-cell">{record.bookingId}</div>
              <div className="invoice-cell">{record.paid.toString()}</div>
              <div className="invoice-cell">{record.paidDate}</div>
              <div className="invoice-cell">{formatAmount(record.amount)}</div>
            </div>
          ))}
        </div>
        {record?.paymentStatus !== 'paid' && (
          <div className="d-flex justify-content-end align-items-center mt-3">
            <Button className="commonBlueBtn commonBlueBtn-cancel" onClick={handleCloseModal}>
              <FormattedMessage id="invoice.button.cancel" />
            </Button>
            <BlueButton
              block
              size="large"
              type="primary"
              htmlType="submit"
              className="btn btn-primary commonBlueBtn"
              onClick={() => handleBankListModalOpen()}
              style={{ float: 'right' }}
            >
              <FormattedMessage id="invoice.button.payNow" />
            </BlueButton>
          </div>
        )}
      </div>
      {/* <div className="d-flex justify-content-center">
        <Loading size={LoadingSise.Normal} className={'margin-top-30'} />
      </div> */}
    </>
  );
};

export default CompanyCreditLineDetails;
